import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalState } from './global-state';
import { ParentMessagesSender } from './parent-messages-sender';
import { filter, map, switchMap, take, finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ExternalApisService {
  private http = inject(HttpClient);
  private globalState = inject(GlobalState);
  private parentMessagesSender = inject(ParentMessagesSender);

  private buildHeaders(token: string): HttpHeaders {
    return new HttpHeaders({ token: token || '' });
  }

  getEdsPortal(): Observable<any> {
    const url = environment.PEDIDOS_API + '/pedidos/eds-portal';
    return this.globalState.token$.pipe(
      filter((t) => !!t && t.length > 0),
      take(1),
      switchMap((token) => {
        const headers = this.buildHeaders(token);
        return this.http.get(url, { headers });
      }),
    );
  }

  getCabecera(rutOrPagador: string): Observable<any> {
    const url =
      environment.CUENTA_API +
      '/cuenta-corriente/datos-cabecera?rut_concesionario=' +
      encodeURIComponent(rutOrPagador);
    return this.globalState.token$.pipe(
      filter((t) => !!t && t.length > 0),
      take(1),
      switchMap((token) => {
        const headers = this.buildHeaders(token);
        return this.http.get(url, { headers });
      }),
    );
  }

  getInstalaciones(pagador: string): Observable<any> {
    const url =
      environment.PEDIDOS_API +
      '/pedidos/obtener-instalaciones-cliente?id_pagador=' +
      encodeURIComponent(pagador);
    return this.globalState.token$.pipe(
      filter((t) => !!t && t.length > 0),
      take(1),
      switchMap((token) => {
        const headers = this.buildHeaders(token);
        return this.http.get(url, { headers });
      }),
    );
  }

  // Devuelve las EDS de un pagador ya parseadas como opciones de dropdown.
  // historicas=false -> INSTALACIONES (vigentes); true -> INSTALACIONES_HISTORICAS (todas).
  getEdsForPagador(
    pagador: string,
    historicas: boolean = false,
  ): Observable<Array<{ label: string; value: number; desde: Date }>> {
    this.parentMessagesSender.displayLoader();
    return this.getInstalaciones(pagador).pipe(
      map((res) => {
        const data = res?.data ?? res ?? {};
        const raw = historicas
          ? data?.INSTALACIONES_HISTORICAS
          : data?.INSTALACIONES;
        const list = Array.isArray(raw) ? raw : [];
        return list.map((e: any) => {
          const desdeArr = String(e?.FDESDE || '2020-01-01').split('-');
          const desdeDate = new Date(
            Number(desdeArr[0] || 0),
            Number(desdeArr[1] || 0),
            Number(desdeArr[2] || 0),
          );
          return {
            label: e?.CODIGO_DIRECCION,
            value: parseInt(e?.ID_EDS, 10),
            desde: desdeDate,
          };
        });
      }),
      finalize(() => this.parentMessagesSender.hideLoader()),
    );
  }
}
